import { Key } from "react";
import useToasts from "../components/ToastManager/useToasts";

export const useFileDownload = () => {
    const { addToast } = useToasts();
    const download = (downloadId: Key) => {
        addToast({
            type: "download",
            typeId: downloadId as string,
            title: "Download läuft",
            progress: 0,
            description: "Dein Download wird vorbereitet."
        });
    };

    return download;
};

export default useFileDownload;
